import { Card } from "react-bootstrap";
import styled from "styled-components";
import { NoRecordCard } from "../../../common/components";
import { Table } from "../../../common/components/core";
import { toDateTimeString } from "../../userActivityLog/utils/dateTime";
import { useHistory } from "react-router-dom";
import { Pagination } from "../../../types/common";
import { PaymentOrderApprover } from "../../../types/payment";
import { adaptPagination, shortenUUID } from "../../../utils/common";

type InvoiceListFullListProps = {
    paymentOrderList: Pagination<PaymentOrderApprover[]> | undefined;
    nextPage: () => void;
    prevPage: () => void;
    toPage: (page: number) => void;
};

const InvoiceListFullList = ({
    paymentOrderList,
    nextPage,
    prevPage,
    toPage,
}: InvoiceListFullListProps): JSX.Element => {
    const pagination = adaptPagination(paymentOrderList);

    return !paymentOrderList ||
        !paymentOrderList.items ||
        paymentOrderList.items.length === 0 ? (
        <NoRecordCard />
    ) : (
        <Card className="mt-4 border-0">
            <Card.Body className="p-0">
                <table className="custom-table">
                    <thead>
                        <tr>
                            <Table.HeaderCell width={155} className="pt-3">
                                Service Provider Name
                            </Table.HeaderCell>
                            <Table.HeaderCell width={155} className="pt-3">
                                Project Name
                            </Table.HeaderCell>
                            <Table.HeaderCell width={155} className="pt-3">
                                Claim ID
                            </Table.HeaderCell>
                            <Table.HeaderCell width={155} className="pt-3">
                                Invoice ID
                            </Table.HeaderCell>
                            <Table.HeaderCell width={155} className="pt-3">
                                Payment Order ID
                            </Table.HeaderCell>
                            <Table.HeaderCell width={155} className="pt-3">
                                Timestamp
                            </Table.HeaderCell>
                        </tr>
                    </thead>
                    <tbody>
                        {paymentOrderList?.items?.map((paymentOrder) => (
                            <InvoiceRow
                                key={paymentOrder.invoiceReferenceId}
                                paymentOrder={paymentOrder}
                            />
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={6}>
                            {
                                <Table.Pagination
                                    backArrowOnClick={prevPage}
                                    nextArrowOnClick={nextPage}
                                    backArrowDisabled={pagination.firstPage}
                                    nextArrowDisabled={pagination.lastPage}
                                    totalPage={pagination.pageCount}
                                    currentPage={pagination.page + 1}
                                    onPageNumberChange={(page) => toPage(page - 1)}
                                />
                                }
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </Card.Body>
        </Card>
    );
};

type InvoiceRowProps = {
    paymentOrder: PaymentOrderApprover;
};

const InvoiceRow = ({ paymentOrder }: InvoiceRowProps) => {
    const history = useHistory();

    return (
        <Table.BodyRow
            onClick={() => {
                history.push(`/invoices/${paymentOrder.invoiceReferenceId}`);
            }}
            onKeyUp={(event:KeyboardEvent) =>
                {(event.keyCode === 13 || event.keyCode === 32) &&
                    history.push(`/invoices/${paymentOrder.invoiceReferenceId}`);
                }
            }
        >
            <StyledTd>{paymentOrder.contractorDisplayName}</StyledTd>
            <StyledTd>{paymentOrder.projectName}</StyledTd>
            <StyledTd>#{shortenUUID(paymentOrder.claimReferenceId)}</StyledTd>
            <StyledTd>#{shortenUUID(paymentOrder.invoiceReferenceId)}</StyledTd>
            <StyledTd>#{paymentOrder.paymentOrderCustomerRef}</StyledTd>
            <StyledTd>{toDateTimeString(paymentOrder.createdAt)}</StyledTd>
        </Table.BodyRow>
    );
};

const StyledTd = styled.td`
    vertical-align: top;
`;

export default InvoiceListFullList;
